export default __webpack_public_path__ + "static/gopher-get-noticed-37a582f3eea6d20e357a8410d23b9ef0.svg";